import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import organization from '_c/organization';
import staffSearch from '_c/staff-search';
import batchUpload from '_c/batch-upload';
import { tableConfig } from './components/config.js';
import { baseHeaders } from 'util/axios-request';
import { getBatchUpdateSalaryList, updateSalaryReasonTypeList, saveBatchUpdateSalaryData,
// 批量调薪-保存调薪数据
downloadBatchUpdateSalaryTpl // 下载模板
} from '@/api/payroll';
var baseURL = process.env.VUE_APP_BASE_API;
export default {
  components: {
    staffSearch: staffSearch,
    batchUpload: batchUpload,
    organization: organization
  },
  data: function data() {
    return {
      baseHeaders: baseHeaders(),
      uploadUrl: baseURL + '/web/tool/upload_file',
      orgData: {
        index: '',
        department_ids: [],
        staff_ids: []
      },
      orgVisible: false,
      reasonTypeList: {},
      // 调薪原因
      allTableData: this.$s.get('salaryBatch') || {
        list: [],
        columns: {}
      },
      tableData: [],
      multipleSelection: [],
      staffId: '',
      initFiles: [],
      pickerOptions: function pickerOptions() {},
      fileFormat: ['.pdf', '.jpg', '.jpeg', '.png'],
      validatePass: function validatePass(rule, value, callback) {
        var prop = rule.prop;
        if (prop !== 'salary_basic_later' && Number(value) >= 0) {
          return callback();
        }
        if (Number(value) > 0) {
          return callback();
        }
        callback(new Error(''));
      }
    };
  },
  created: function created() {
    var _this = this;
    this.getReasonTypeList();
    this.orgVisible = !this.allTableData.list.length;
    if (!this.orgVisible) this.handleTableData(this.allTableData);
    // 可选择对应员工入职日期以后日期
    this.$nextTick(function () {
      _this.pickerOptions = function (row) {
        return {
          disabledDate: function disabledDate(time) {
            return time.getTime() < new Date(row.hire_date).getTime();
          }
        };
      };
    });
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    contentViewHeight: function contentViewHeight(state) {
      return state.settings.contentViewHeight;
    }
  })), {}, {
    tableHeight: function tableHeight() {
      return this.contentViewHeight - 177;
    }
  }),
  methods: {
    handlerBack: function handlerBack() {
      this.$router.go(-1);
    },
    // 获取数据
    getSelectNode: function getSelectNode(val) {
      var _this2 = this;
      this.orgData.department_ids = val.depIds;
      this.orgData.staff_ids = val.staffIds;
      getBatchUpdateSalaryList({
        department_ids: this.orgData.department_ids,
        staff_ids: this.orgData.staff_ids
      }).then(function (res) {
        _this2.handleTableData(res.data || []);
      });
    },
    // 处理表头数据
    handleColumn: function handleColumn(_ref) {
      var columns = _ref.columns;
      var arr = [];
      tableConfig.forEach(function (item) {
        if (columns[item.prop]) {
          arr.push(item);
          delete columns[item.prop];
        }
      });
      if (Array.isArray(columns)) return;
      var keys = Object.keys(columns);
      keys.forEach(function (item) {
        var obj = {
          edit: false,
          type: '',
          label: columns[item],
          prop: item,
          width: 200
        };
        // 调薪后可编辑
        if (item.indexOf('later') !== -1) {
          obj.edit = true;
          obj.type = 'number';
        }
        // 操作原因
        if (['update_reason_type', 'salary_update_start_date', 'update_reason_remark'].includes(item)) {
          obj.edit = true;
          obj.type = 'input';
          if (item === 'update_reason_type') obj.type = 'select';
          if (item === 'salary_update_start_date') obj.type = 'picker';
        }
        arr.push(obj);
      });
      return arr;
    },
    // 处理表格数据
    handleTableData: function handleTableData(val) {
      var keys = Object.keys(this.allTableData.columns);
      if (!keys.length) {
        this.allTableData.columns = this.handleColumn(val);
      }
      // 列表去重
      var obj = {};
      this.allTableData.list.forEach(function (item) {
        obj[item.staff_phone] = item;
      });
      if (val.list && val.list.length) {
        val.list.forEach(function (item) {
          if (obj[item.staff_phone]) {
            obj[item.staff_phone] = Object.assign({}, obj[item.staff_phone], item);
          } else {
            obj[item.staff_phone] = item;
          }
          var keys = Object.keys(obj[item.staff_phone]);
          keys.forEach(function (key) {
            if (key.indexOf('later') !== -1) {
              var str = String(obj[item.staff_phone][key]);
              obj[item.staff_phone][key] = str ? obj[item.staff_phone][key] : undefined;
            }
          });
        });
      }
      this.allTableData.list = Object.values(obj);
      this.tableData = this.allTableData.list;
      this.$s.set('salaryBatch', this.allTableData);
    },
    // 调薪原因
    getReasonTypeList: function getReasonTypeList() {
      var _this3 = this;
      updateSalaryReasonTypeList().then(function (res) {
        if (res && res.code === 1) {
          _this3.reasonTypeList = res.data;
        }
      });
    },
    // 添加调薪人员
    addStaff: function addStaff() {
      this.orgVisible = true;
    },
    // 搜索
    staffChange: function staffChange(val) {
      this.staffId = val.staff_id;
    },
    handleSubmit: function handleSubmit() {
      var _this4 = this;
      if (!this.staffId) {
        this.tableData = this.allTableData.list;
        return;
      }
      var data = this.allTableData.list.filter(function (item) {
        return item.staff_info_id === _this4.staffId;
      });
      this.tableData = data;
    },
    // 选中
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 批量删除
    batchDelete: function batchDelete() {
      var _this5 = this;
      this.$confirm(this.$t('i18n.9ca200c0512c4453bfd78626d3943fc6', {
        x: this.multipleSelection.length
      }), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        _this5.handleDelete(_this5.multipleSelection);
      }).catch(function () {});
    },
    handleDelete: function handleDelete(data) {
      var obj = {};
      data.forEach(function (item) {
        return obj[item.staff_info_id] = item;
      });
      var list = this.allTableData.list.filter(function (item, index) {
        return !obj[item.staff_info_id];
      });
      this.allTableData.list = list;
      this.$s.set('salaryBatch', this.allTableData);
      // 批量删除后对应搜索字段重新筛选数据
      this.handleSubmit();
    },
    // 批量导入
    handleImport: function handleImport() {
      var ids = [];
      this.allTableData.list.forEach(function (item) {
        ids.push(item.staff_info_id);
      });
      var data = {
        title: this.$t('i18n.ea76732a9cb443b3a964e602babf84bc'),
        list: {
          1: {
            name: this.$t('bulkImport'),
            label: '1',
            tip: this.$t('i18n.d47430700982442fa686294f0a5bd7b0'),
            download: this.$t('i18n.18c86f2f267c4f01b9d80462a4281215'),
            download_text: this.$t('1373'),
            download_api: downloadBatchUpdateSalaryTpl,
            upload: this.$t('39'),
            upload_text: this.$t('52'),
            upload_tip: this.$t('i18n.f502f233c5d445df93392a7ab3e8dafe', {
              type: '.xls、.xlsx'
            }),
            upload_api: 'web/payroll_staff/uploadBatchUpdateSalaryData',
            type: '2',
            emit: true,
            query: {
              staff_ids: ids,
              department_ids: []
            }
          }
        }
      };
      this.$refs.batchUpload.init(data);
    },
    uploadSubmit: function uploadSubmit(val) {
      this.handleTableData(val);
    },
    // 导入调薪数据
    onSave: function onSave() {
      var _this6 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          saveBatchUpdateSalaryData({
            list: _this6.allTableData.list
          }).then(function (res) {
            if (!res.data) return;
            var state = Number(res.data.all_count) === Number(res.data.success_count);
            var list = [];
            _this6.$confirm(state ? _this6.$t('i18n.20291e5ae8624c478bbc98633071f7dc', {
              count: res.data.all_count
            }) : "<p>".concat(_this6.$t('i18n.6b0e6f58421541969c53cbf845346d03', {
              count: Number(res.data.all_count)
            }), "</p>\n                <p>").concat(_this6.$t('i18n.921bc9d492884b4d92ab6afdc6437f77', {
              success: Number(res.data.success_count)
            }), "</p>\n                <p>").concat(_this6.$t('i18n.a615efc4d78e4002abb94bcfac8ff6ca', {
              fail: Number(res.data.error_count)
            }), "</p>\n                <p>").concat(_this6.$t('i18n.3b20b154f8ac4687a57c915c76b03033'), "</p>"), state ? _this6.$t('i18n.f948eab8d5c74951b0d2cbb36c174872') : _this6.$t('i18n.b92ec430413b4d529caf19b3df3124b6'), {
              dangerouslyUseHTMLString: true,
              showCancelButton: false,
              confirmButtonText: state ? _this6.$t('131') : _this6.$t('i18n.b92ec430413b4d529caf19b3df3124b6'),
              cancelButtonText: _this6.$t('66'),
              closeOnClickModal: false,
              type: state ? 'success' : 'warning'
            }).then(function () {
              if (!state) window.open(res.data.file_path);
            }).catch(function () {}).finally(function () {
              // 有错误数据展示，没有返回上一页
              if (state) {
                _this6.handlerBack();
              } else {
                res.data.error_msg.forEach(function (item, index) {
                  if (!Number(item.state)) list.push(_this6.allTableData.list[index]);
                });
                _this6.allTableData.list = list;
                _this6.tableData = _this6.allTableData.list;
                _this6.$s.set('salaryBatch', _this6.allTableData);
              }
            });
          });
        }
      });
    },
    // 上传失败 err, file, fileList
    errorHandle: function errorHandle(err) {
      var msg = JSON.parse(err['message']);
      this.$message.error(msg.message);
      throw err;
    },
    handleClear: function handleClear(row) {
      row.update_reason_file = '';
    },
    handleCheck: function handleCheck(row) {
      window.open(row.update_reason_file, '_blank');
    },
    handleUpload: function handleUpload(index) {
      this.orgData.index = index;
    },
    // 上传成功+
    successHandle: function successHandle(res) {
      this.$message.success(this.$t('818'));
      var index = this.orgData.index;
      this.$set(this.allTableData.list[index], 'update_reason_file', res.data.object_url || '');
      this.$s.set('salaryBatch', this.allTableData);
    },
    exceedHandle: function exceedHandle() {
      this.$message.error(this.$t('payroll_management_58', {
        fileLimit: 1
      }));
    },
    beforeUploadHandle: function beforeUploadHandle(file) {
      //  文件扩展名
      if (this.fileFormat.length) {
        var fileExtend = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
        if (this.fileFormat.indexOf(fileExtend) <= -1) {
          this.$message.error(this.$t('729', {
            fileFormat: this.fileFormat.join()
          }));
          return false;
        }
      }
    },
    handleCacle: function handleCacle(row) {
      var _this7 = this;
      this.$confirm(this.$t('i18n.7aaa531b06b648fbb72682f992c0db5d'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        _this7.handleDelete([row]);
      }).catch(function () {});
    }
  },
  beforeDestroy: function beforeDestroy() {
    // 删除本地存储的salaryBatch
    this.$s.remove('salaryBatch');
  }
};